export default __webpack_public_path__ + "branch-with-leaves-black-shape.png";